import React, { useEffect, useState } from "react";

import ExcelJS from "exceljs";
import { saveAs } from "file-saver";
import { Button, notification, message, Tooltip, Space } from "antd";
import { FileExcelOutlined, FileTextOutlined } from "@ant-design/icons";
import getDetalleVisitaPorTipo from "../../../../services/visitas_tecnicas/getDetalleVisitasportipoService";
import obtenerCategoriasProductos from "../../../../services/visitas_tecnicas/getCategoriaProductosService";
import { useSelector } from "react-redux";
import normalizarCoordenada from "../../../../utils/normalizarGeoreferencias";

const Export_medicionCapacidadSalida = () => {
  const [dataCompleta, setDataCompleta] = useState([]);
  const [dataCategoriasxproducto, setDataCategoriasxproducto] = useState([]);
  const [loading, setLoading] = useState(false); // Estado de carga
  const [loadingExcel, setLoadingExcel] = useState(false); // Estado para Excel
  const [loadingJson, setLoadingJson] = useState(false); // Estado para JSON
  const usernameFromState = useSelector((state) => state.auth.user);

  const fetchDetalleVisitas = async () => {
    try {
      const response = await getDetalleVisitaPorTipo(
        8,
        usernameFromState.email
      );
      const { status, results } = response;

      if (status === 200) {
        setDataCompleta(results);
      } else {
        notification.error({
          message: "Error",
          description: message || "Failed to fetch detalle visitas data.",
        });
      }
    } catch (error) {
      notification.error({
        message: "Error",
        description: "An error occurred while fetching data.",
      });
    } finally {
    }
  };

  function groupByLineaProductiva(datos) {
    return datos.reduce((acc, item) => {
      const { lineaProductiva } = item.detalle;

      if (!acc[lineaProductiva]) {
        acc[lineaProductiva] = [];
      }

      acc[lineaProductiva].push(item);
      return acc;
    }, {});
  }

  const cargarCategoriasYProductos = async (data) => {
    try {
      const response = await obtenerCategoriasProductos();
      if (response.success) {
        setDataCategoriasxproducto(response);
      } else {
        setDataCategoriasxproducto([]);

        console.error(
          "Error al cargar categorías y productos:",
          response.message
        );
      }
    } catch (error) {
      console.error("Error al cargar datos:", error);
    }
  };

  const obtenerDescribcionesCategoriasYproductos = async (data) => {
    if (dataCategoriasxproducto) {
      // Extraer categorías y productos en mapas para acceso rápido
      const categoriaMap = new Map(
        dataCategoriasxproducto.categorias.map((cat) => [cat.id, cat.nombre])
      );
      const productoMap = new Map(
        dataCategoriasxproducto.productos.map((prod) => [prod.id, prod.nombre])
      );

      // Verificar que `lista_productos_fortalecimiento_economico` sea un array antes de hacer `.map()`
      if (Array.isArray(data)) {
        const listaFormateada = data.map((item) => ({
          categoria: categoriaMap.get(item.categoria) || "Desconocido",
          productos: Array.isArray(item.producto)
            ? item.producto.map(
                (id) => productoMap.get(id) || "Producto Desconocido"
              )
            : [],
        }));

        return listaFormateada;
      } else {
        return [];
      }
    } else {
      console.error("Error al cargar categorías y productos:");
    }
  };

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      await Promise.all([fetchDetalleVisitas(), cargarCategoriasYProductos()]);
      setLoading(false);
    };

    fetchData();
  }, []);
  const exportToExcel = async () => {
    try {
      if (dataCompleta.length === 0) {
        notification.warning({
          message: "Advertencia",
          description: "No hay datos disponibles para exportar.",
          duration: 3,
        });
        return;
      }

      setLoadingExcel(true);
      const workbook = new ExcelJS.Workbook();

      // Cargar la plantilla de Excel
      const templateResponse = await fetch(
        "/assets/plantilla_medicion_capacidades.xlsx"
      );
      const templateBuffer = await templateResponse.arrayBuffer();

      await workbook.xlsx.load(templateBuffer);

      const calificaciones = ["Muy Bajo", "Bajo", "Medio", "Alto", "Muy Alto"];

      function obtenerDescripcionCalificacion(calificacion) {
        return calificacion
          ? calificaciones[calificacion - 1] || "Sin evidencia"
          : "Sin evidencia";
      }

      function asignarCalificaciones(
        worksheet,
        currentRow,
        calificacionesObj,
        columnas,
        keys
      ) {
        if (!calificacionesObj || !Array.isArray(keys)) return; // Validación para evitar errores
        keys.forEach((key, index) => {
          const valor = calificacionesObj?.[key]?.valor;
          worksheet.getCell(`${columnas[index]}${currentRow}`).value =
            obtenerDescripcionCalificacion(valor);
        });
      }

      function llenarColumnasComunes(worksheet, item, currentRow) {
        // Paso 1
        worksheet.getCell(`A${currentRow}`).value =
          item.detalle.id_participante || "";
        worksheet.getCell(`B${currentRow}`).value =
          item.detalle.modalidad_visita || "";
        worksheet.getCell(`C${currentRow}`).value =
          item.detalle.lugar_visita || "";
        worksheet.getCell(`D${currentRow}`).value =
          normalizarCoordenada(item.detalle.latuser) ?? "";
        worksheet.getCell(`E${currentRow}`).value =
          normalizarCoordenada(item.detalle.lnguser) ?? "";

        // Paso 2
        worksheet.getCell(`F${currentRow}`).value =
          item.detalle.quien_responde || "";
        worksheet.getCell(`G${currentRow}`).value =
          item.detalle.nombre_persona || "";
        worksheet.getCell(`H${currentRow}`).value =
          item.detalle.rango_edad || "";
        worksheet.getCell(`I${currentRow}`).value = item.detalle.genero || "";
        worksheet.getCell(`J${currentRow}`).value =
          item.detalle.estado_embarazo || "";

        worksheet.getCell(`K${currentRow}`).value =
          item.detalle.nivel_escolaridad || "";

        worksheet.getCell(`L${currentRow}`).value =
          item.detalle.grupo_etnico || "";

        worksheet.getCell(`M${currentRow}`).value =
          item.detalle.discapacidad || "";

        worksheet.getCell(`N${currentRow}`).value =
          item.detalle.tipo_discapacidad || "";

        worksheet.getCell(`O${currentRow}`).value =
          item.detalle.horas_actividad_cuidado || "";

        // Paso 3
        worksheet.getCell(`P${currentRow}`).value =
          item.detalle.nombreProyecto || "";
        worksheet.getCell(`Q${currentRow}`).value =
          item.detalle.codigoPreIni || "";
        worksheet.getCell(`R${currentRow}`).value =
          item.detalle.tipoProyecto || "";
        worksheet.getCell(`S${currentRow}`).value =
          item.detalle.estadoProyecto || "";
        worksheet.getCell(`T${currentRow}`).value =
          item.detalle.lineaProductiva || "";
        worksheet.getCell(`U${currentRow}`).value =
          item.detalle.cambioLineaProductiva || "";
        worksheet.getCell(`V${currentRow}`).value =
          item.detalle.documento_avala_cambio_diligenciado || "";
        worksheet.getCell(`W${currentRow}`).value =
          item.detalle.tenenciaPredio || "";
        worksheet.getCell(`X${currentRow}`).value =
          item.detalle.otraTenenciaPredio || "";
        worksheet.getCell(`Y${currentRow}`).value =
          item.detalle.areaPredio || "";
        worksheet.getCell(`Z${currentRow}`).value =
          item.detalle.zonaPredio || "";

        // Paso 4
        const socioClave =
          item.detalle.socios_claves === "Otro"
            ? item.detalle.otra_socio_clave || ""
            : item.detalle.socios_claves || "";

        worksheet.getCell(`AA${currentRow}`).value = socioClave;

        let riesgos = [];

        if (Array.isArray(item.detalle.riesgos_desarrollo_negocio)) {
          riesgos = item.detalle.riesgos_desarrollo_negocio.map((r) =>
            r === "Otro"
              ? item.detalle.otro_riesgos_desarrollo_negocio || ""
              : r
          );
        }

        worksheet.getCell(`AB${currentRow}`).value = riesgos.join(", ");

        worksheet.getCell(`AC${currentRow}`).value =
          item.detalle.otras_fuentes_ingreso || "";

        worksheet.getCell(`AD${currentRow}`).value =
          item.detalle.cuales_fuentes_ingreso || "";

        worksheet.getCell(`AE${currentRow}`).value =
          item.detalle.acceso_recursos || "";

        worksheet.getCell(`AF${currentRow}`).value =
          item.detalle.cuales_acceso_recursos || "";

        // Capacidades Socio-Empresarial
        const calificacionesKeys = [
          "1.1",
          "2.1",
          "2.2",
          "2.3",
          "3.1",
          "3.2",
          "3.3",
          "3.4",
          "3.5",
          "4.1",
        ];

        const columnas = [
          "AG",
          "AH",
          "AI",
          "AJ",
          "AK",
          "AL",
          "AM",
          "AN",
          "AO",
          "AP",
        ];

        asignarCalificaciones(
          worksheet,
          currentRow,
          item?.detalle?.capacidades_socio_empresarial?.calificacion || {},
          columnas,
          calificacionesKeys
        );

        // Paso 5
        worksheet.getCell(`AQ${currentRow}`).value =
          item?.detalle?.capacitacion_igualdad_genero || "";
        worksheet.getCell(`AR${currentRow}`).value =
          item?.detalle?.implementado_practicas_equidad_genero || "";
        worksheet.getCell(`AS${currentRow}`).value = Array.isArray(
          item?.detalle?.responsable_acitividades_cuidado_hogar
        )
          ? item.detalle.responsable_acitividades_cuidado_hogar.join(", ")
          : item?.detalle?.responsable_acitividades_cuidado_hogar ?? "";
        worksheet.getCell(`AT${currentRow}`).value =
          item?.detalle?.carga_trabajo_afecta_productividad || "";

        //CAPACIDADES DE ENFOQUE TRANSVERSAL

        asignarCalificaciones(
          worksheet,
          currentRow,
          item?.detalle?.capacidades_enfoque_transversal?.calificacion || {},
          ["AU", "AV"],
          ["1.1", "1.2"]
        );
      }

      const procesarHojaAgricola = async (worksheet, data) => {
        if (!Array.isArray(data) || data.length === 0) {
          console.warn("No hay datos válidos para procesar servicios:", data);
          return; // Salimos de la función si no hay datos
        }
        let currentRow = 5; // Fila inicial
        for (const item of data) {
          const startRow = currentRow; // Fila de inicio para esta entrada
          let maxRow = currentRow; // Variable para rastrear la fila más baja ocupada

          llenarColumnasComunes(worksheet, item, startRow);

          const agricola = item.detalle.agricola || {};

          worksheet.getCell(`AW${startRow}`).value =
            agricola.area_produccion || "";
          worksheet.getCell(`AX${startRow}`).value = agricola.area_bosque || "";
          worksheet.getCell(`AY${startRow}`).value = agricola.area_predio || "";
          worksheet.getCell(`AZ${startRow}`).value =
            agricola.numero_plantas_sembradas || "";
          worksheet.getCell(`BA${startRow}`).value =
            agricola.distancia_sembrada || "";
          worksheet.getCell(`BB${startRow}`).value =
            agricola.variedad_sembrada || "";
          worksheet.getCell(`BC${startRow}`).value = Array.isArray(agricola?.meses_siembra)
        ? agricola.meses_siembra.join(", ")
        : agricola?.meses_siembra || "";
          worksheet.getCell(`BD${startRow}`).value =
            agricola.manejo_registros || "";

          // Comercialización
          const listaComercializacion = agricola.lista_comercializacion || [];
          if (listaComercializacion.length > 0) {
            currentRow = startRow; // Fila de inicio para esta entrada
            listaComercializacion.forEach((comercializacion) => {
              worksheet.getCell(`BE${currentRow}`).value =
                comercializacion.producto || "";
              worksheet.getCell(`BF${currentRow}`).value =
                comercializacion.cantidad_mes_ano || "";
              worksheet.getCell(`BG${currentRow}`).value =
                comercializacion.venta_unidad || "";
              worksheet.getCell(`BH${currentRow}`).value =
                comercializacion.cliente || "";
              currentRow++; // Avanzar fila solo si hay comercialización
            });

            maxRow = Math.max(maxRow, currentRow);
          } else {
            // No hubo comercialización, avanzamos al menos una fila
            maxRow = Math.max(maxRow, startRow + 1);
          }

          // CAPACIDADES AGRICOLAS
          asignarCalificaciones(
            worksheet,
            startRow,
            item?.detalle?.capacidades_agricola?.calificacion || {},
            [
              "BI",
              "BJ",
              "BK",
              "BL",
              "BM",
              "BN",
              "BO",
              "BP",
              "BQ",
              "BR",
              "BS",
              "BT",
              "BU",
              "BV",
              "BW",
              "BX",
              "BY",
              "BZ",
              "CA",
              "CB",
            ],
            [
              "1.1",
              "1.2",
              "1.3",
              "1.4",
              "1.5",
              "2.1",
              "2.2",
              "3.1",
              "4.1",
              "4.2",
              "4.3",
              "5.1",
              "5.2",
              "5.3",
              "6.1",
              "6.2",
              "7.1",
              "7.2",
              "7.3",
              "7.4",
            ]
          );

          worksheet.getCell(`CC${startRow}`).value =
            item?.detalle?.fuente || "";
          worksheet.getCell(`CD${startRow}`).value = item?.name || "";
          worksheet.getCell(`CE${startRow}`).value = item?.email || "";
          worksheet.getCell(`CF${startRow}`).value = item?.estado || "";

          for (let row = startRow; row <= maxRow; row++) {
            worksheet.getCell(`A${row}`).value =
              item.detalle.id_participante || "";
          }

          currentRow = maxRow;
        }
      };

      const procesarHojaPecuaria = async (worksheet, data) => {
        if (!Array.isArray(data) || data.length === 0) {
          console.warn("No hay datos válidos para procesar servicios:", data);
          return; // Salimos de la función si no hay datos
        }
        let currentRow = 5; // Fila inicial

        for (const item of data) {
          const startRow = currentRow; // Fila de inicio para esta entrada
          let maxRow = currentRow; // Variable para rastrear la fila más baja ocupada
          llenarColumnasComunes(worksheet, item, startRow);

          //CAPACIDADES DE PECUARIA
          asignarCalificaciones(
            worksheet,
            startRow,
            item?.detalle?.capacidades_pecuario?.calificacion || {},
            [
              "AW",
              "AX",
              "AY",
              "AZ",
              "BA",
              "BB",
              "BC",
              "BD",
              "BE",
              "BF",
              "BG",
              "BH",
              "BI",
              "BJ",
              "BK",
              "BL",
              "BM",
              "BN",
              "BO",
            ],
            [
              "1.1",
              "1.2",
              "2.1",
              "3.1",
              "4.1",
              "5.1",
              "5.2",
              "5.3",
              "5.4",
              "6.1",
              "7.1",
              "7.2",
              "8.1",
              "9.1",
              "10.1",
              "10.2",
              "10.3",
              "10.4",
              "10.5",
            ]
          );

          worksheet.getCell(`BP${startRow}`).value =
            item?.detalle?.fuente || "";

          worksheet.getCell(`BQ${startRow}`).value = item?.name || "";
          worksheet.getCell(`BR${startRow}`).value = item?.email || "";
          worksheet.getCell(`BS${startRow}`).value = item?.estado || "";

          for (let row = startRow; row <= maxRow; row++) {
            worksheet.getCell(`A${row}`).value =
              item.detalle.id_participante || "";
          }
          currentRow = maxRow;
        }
      };

      const procesarHojaServicios = async (worksheet, data) => {
        if (!Array.isArray(data) || data.length === 0) {
          console.warn("No hay datos válidos para procesar servicios:", data);
          return; // Salimos de la función si no hay datos
        }

        let currentRow = 5; // Fila inicial

        for (const item of data) {
          let startRow = currentRow; // Fila de inicio del item

          llenarColumnasComunes(worksheet, item, startRow);

          // Capacidades servicios
          asignarCalificaciones(
            worksheet,
            startRow,
            item?.detalle?.capacidades_servicios?.calificacion || {},
            ["AW", "AX", "AY", "AZ", "BA", "BB", "BC", "BD", "BE"],
            ["1.1", "1.2", "2.1", "3.1", "34.1", "5.1", "5.2", "6.1", "7.1"]
          );

          worksheet.getCell(`BF${startRow}`).value = item.detalle.fuente || "";

          worksheet.getCell(`BG${startRow}`).value = item?.name || "";
          worksheet.getCell(`BH${startRow}`).value = item?.email || "";
          worksheet.getCell(`BI${startRow}`).value = item?.estado || "";

          for (let row = startRow; row <= currentRow; row++) {
            worksheet.getCell(`A${row}`).value =
              item.detalle.id_participante || "";
          }
        }
      };

      const datosAgrupados = groupByLineaProductiva(dataCompleta);

      const datasets = [
        {
          name: "Agrícola",
          data: datosAgrupados.Agrícola,
          processor: procesarHojaAgricola,
        },

        {
          name: "Pecuaria",
          data: datosAgrupados.Pecuaria,
          processor: procesarHojaPecuaria,
        },
        {
          name: "Servicios",
          data: datosAgrupados.Servicios,
          processor: procesarHojaServicios,
        },
      ];

      await Promise.all(
        datasets.map(async ({ name, data, processor }) => {
          let worksheet = workbook.getWorksheet(name);
          if (!worksheet) {
            worksheet = workbook.addWorksheet(name);
          }
          await processor(worksheet, data); // ✅ Ahora espera a que termine cada procesamiento
        })
      );

      // Descargar el archivo modificado
      const buffer = await workbook.xlsx.writeBuffer();
      const blob = new Blob([buffer], { type: "application/octet-stream" });
      saveAs(blob, "Informe_medicion_capacidades_salida.xlsx");
      notification.success({
        message: "Exito",
        description: "Excel exportado correctamente.",
        duration: 3,
      });
    } catch (error) {
      console.error("Error al generar Excel:", error);
      notification.error({
        message: "Error",
        description: "No se pudo exportar el Excel.",
        duration: 3,
      });
    } finally {
      setLoadingExcel(false);
    }
  };

  const exportToJSON = async () => {
    try {
      if (!dataCompleta || dataCompleta.length === 0) {
        notification.warning({
          message: "Advertencia",
          description: "No hay datos disponibles para exportar.",
          duration: 3,
        });
        return;
      }
      setLoadingJson(true);

      // Convertir data a JSON y descargar
      const jsonBlob = new Blob([JSON.stringify(dataCompleta, null, 2)], {
        type: "application/json",
      });
      saveAs(jsonBlob, "Informe_medicion_capacidades_salida.json");

      notification.success({
        message: "Éxito",
        description: "JSON exportado correctamente.",
        duration: 3,
      });
    } catch (error) {
      console.error("Error al generar JSON:", error);
      notification.error({
        message: "Error",
        description: "No se pudo exportar el JSON.",
        duration: 3,
      });
    } finally {
      setLoadingJson(false);
    }
  };
  return (
    <Space>
      <Tooltip title="Exportar datos en XLSX">
        <Button
          type="default"
          icon={<FileExcelOutlined />}
          onClick={exportToExcel}
          loading={loading || loadingExcel}
          disabled={loading || loadingExcel}
          style={{
            backgroundColor: "#52c41a",
            borderColor: "#52c41a",
            color: "white",
          }}
        />
      </Tooltip>

      <Tooltip title="Exportar datos en JSON">
        <Button
          type="default"
          icon={<FileTextOutlined />}
          onClick={exportToJSON}
          loading={loading || loadingJson}
          disabled={loading || loadingJson}
          style={{
            backgroundColor: "#C2BCBC",
            borderColor: "#C2BCBC",
            color: "white",
          }}
        />
      </Tooltip>
    </Space>
  );
};

export default Export_medicionCapacidadSalida;
